import { motion } from "framer-motion";
import { ASSETS, SPACE } from "../../data/content";
import { FadeUp, MaskLineInView } from "./Reveal";

const Frame = ({ src, alt, className, arch = true, testid, delay = 0 }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay }}
    className={`group relative overflow-hidden ${arch ? "arch-top" : "rounded-2xl"} ${className}`}
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
    />
    <div className="absolute inset-0 bg-[#07412b]/0 group-hover:bg-[#07412b]/10 transition-colors duration-500" />
  </motion.div>
);

export const TheSpace = () => {
  return (
    <section
      id="space"
      data-testid="space-section"
      className="bg-[#052e1e] py-12 lg:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <FadeUp>
            <span className="font-body text-[#ddb128] text-[13px] tracking-[0.3em] uppercase">
              {SPACE.label}
            </span>
          </FadeUp>
          <h2 className="font-display text-[#f7f3e9] text-[52px] sm:text-7xl lg:text-[110px] leading-[1] mt-2 whitespace-pre-line">
            {SPACE.headline.split("\n").map((line, i) => (
              <MaskLineInView key={i} delay={i * 0.12}>
                {line}
              </MaskLineInView>
            ))}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 sm:gap-6 mt-8 items-stretch">
          <Frame
            testid="space-img-1"
            src={ASSETS.bedroomMorocco}
            alt="The Moroccan-inspired bedroom"
            className="lg:col-span-7 h-[420px] sm:h-[560px] lg:h-[640px]"
          />
          <Frame
            testid="space-img-2"
            src={ASSETS.roomInterior}
            alt="A restful room with a view into the garden"
            arch={false}
            delay={0.08}
            className="lg:col-span-5 h-[420px] sm:h-[560px] lg:h-[640px]"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-16">
          <div className="lg:col-span-8 lg:col-start-5 space-y-6">
            {SPACE.lines.map((l, i) => (
              <FadeUp key={i} delay={i * 0.06}>
                <p
                  className={`font-body font-light leading-relaxed ${
                    i === SPACE.lines.length - 1
                      ? "font-script not-italic text-[#ddb128] text-4xl sm:text-5xl leading-tight"
                      : "text-[#f7f3e9]/80 text-base sm:text-lg"
                  }`}
                >
                  {l}
                </p>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
